export default {
  header: {
    title: 'お支払い情報の入力',
    alt: 'お支払い'
  },
  customer: {
    header: 'ご注文者情報を入力',
    name: 'お名前：',
    nameLabelNote: '※ 銀行振込で購入の際は請求書の宛名として印字されます。',
    namePlaceholder: '星野太郎',
    nameNote1: '※ 漢字仮名、英字で入力してください。',
    nameKana: 'フリガナ：',
    nameKanaPlaceholder: 'ホシノタロウ',
    nameKanaNote1: '※ カタカナ、英字で入力してください。',
    telephone: '電話番号：',
    telephonePlaceholder: '08012345678',
    email: 'メールアドレス：',
    emailPlaceholder: 'taro@hoshinoresorts.com'
  },
  payment: {
    header: 'お支払い情報を入力',
    card: {
      select: 'カード決済',
      kind: '利用可能カード：',
      count: '支払い回数：',
      countNote: '一括のみ',
      cardno: 'カード番号：',
      cardnoPlaceholder: '0000000000000000',
      expires: '有効期限：',
      holdername: 'カード名義人：',
      holdernamePlaceholder: 'HOSHINO TARO',
      holdernameNote: '※ 英字で入力してください。',
      securitycode: 'セキュリティコード：',
      securitycodePlaceholder: '012',
      securitycodeNote:
        '※ カード裏面の署名欄等に記載の3桁または4桁の数字を入力してください。'
    },
    bank: {
      select: '銀行振込',
      transferFee: '振込手数料：',
      transferFeeNote: 'お客様負担',
      payerName: '振込時依頼人名：',
      payerNamePlaceholder: 'ﾎｼﾉﾀﾛｳ',
      payerNameNote1: '※ カタカナ、英字のみで入力してください。',
      payerNameNote2:
        '※ 銀行振込時に上記のお名前を「振込依頼人」としてお振込みください。',
      transferAccount: 'お振込み先口座について：',
      transferAccountNote:
        '注文完了後、ご注文者様のメールアドレス宛に送付される「請求書発行Eメール」にてお知らせいたします。',
      transferDate: 'お振込み期日：',
      transferDateNote1: '注文完了から1ヶ月以内',
      transferDateNote2:
        '※ 商品の発送は、お振込み後、弊社にて着金確認した後となります。予めご了承願います。'
    }
  },
  delivery: {
    header: '配送について',
    preferredOn: '指定する',
    preferredOff: '指定しない(最短でのお届け)',
    preferredDate: '到着希望日：',
    preferredTime: '到着希望時間：',
    morning: '午前中(12時まで)',
    afternoon1: '午後14時〜16時',
    afternoon2: '午後16時〜18時',
    night: '夜間19時〜21時',
    none: '指定しない',
    aboutDelivery: 'お届けについて：',
    aboutDeliveryNote1:
      '商品出荷後、お荷物お問い合わせ番号を「注文確認」ページにてお知らせいたします。',
    aboutReturn: '返品について：',
    aboutReturnNote: 'ご注文確定後の返品・交換はお請けいたしておりません。'
  },
  submit: '注文内容の確認へ',
  back: '戻る',
  multiPaymentErrorMessages: {
    '100': 'カード番号が指定されていません。',
    '101': 'カード番号に数字以外の文字が含まれています。',
    '102': 'カード番号が10桁～16桁の範囲ではありません。',
    '110': '有効期限が指定されていません。',
    '111': '有効期限に数字以外の文字が含まれています。',
    '112': '有効期限が4桁ではありません。',
    '113': '有効期限の入力に誤りがあります。',
    '121': 'セキュリティコードに数字以外の文字が含まれています。',
    '122': 'セキュリティコードの入力に誤りがあります。',
    '131': 'カード名義人の入力に誤りがあります',
    '132': 'カード名義人の入力に誤りがあります',
    '902':
      'ただいまサーバーが混み合っております。しばらくしてからもう一度やり直してください。',
    others:
      'エラーが発生しました。申し訳ございませんが、しばらくしてからもう一度やり直してください。'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/payment.js